/*
 * Created Date: 20-01-2024, 11:33:24 am
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Sat Jan 20 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import { StyledEngineProvider } from '@mui/system'
import CoreAppProvider from './CoreAppProvider'
import MUIThemeProvider from './MUIThemeProvider'
import MultiLanguageProvider from './MultiLanguageProvider'

const AppProvider = props => {
	return (
		<MUIThemeProvider>
			<StyledEngineProvider injectFirst>
				<MultiLanguageProvider>
					<CoreAppProvider>{props.children}</CoreAppProvider>
				</MultiLanguageProvider>
			</StyledEngineProvider>
		</MUIThemeProvider>
	)
}

export default AppProvider
